import Chart from 'chart.js/auto'
import { OA_TYPES, OA_TYPES_BG_COLORS } from './config';

export default class StackedBarChartOAType {

  constructor(elementId, data) {
    this.elementId = elementId;
    this.data = data;
    this.datasets = []

    this.initDatasets();
    this.addGraph();
  }

  getPercentageByYearAndKey(year, key) {
    try {
      const share = (
        this.data[year]["oa_aggregation"].find((elem) => elem["_id"] === key).count /
        this.getTotalByYear(year)
      )
      return share.toFixed(4) * 100
    } catch (error) {
      return 0
    }
  }

  getTotalByYear(year) {
    return this.data[year]["oa_aggregation"].reduce((acc, elem) => {
      return acc + elem.count
    }, 0)
  }

  initDatasets() {
    for (const oa_type of OA_TYPES) {
      const dataset = {
        label: oa_type,
        data: [
          this.getPercentageByYearAndKey("2021", oa_type),
          this.getPercentageByYearAndKey("2022", oa_type),
          this.getPercentageByYearAndKey("2023", oa_type),
          this.getPercentageByYearAndKey("2024", oa_type),
          this.getPercentageByYearAndKey("2025", oa_type),
        ],
        backgroundColor: OA_TYPES_BG_COLORS[oa_type]
      }
      this.datasets.push(dataset)
    }
  }

  addGraph() {
    const data = {
      labels: [
        '2021',
        '2022',
        '2023',
        '2024',
        '2025',
      ],
      datasets: this.datasets
    };

    new Chart(
      document.getElementById(this.elementId),
        {
          type: 'bar',
          data: data,
          options: {
            backgroundColor: '#FFFFFF',
            scales: {
              x: {
                stacked: true
              },
              y: {
                stacked: true
              }
            }
          }
        }
    );
  }
}
